import { render, staticRenderFns } from "./OffersDatesFilter.vue?vue&type=template&id=6877b77c&scoped=true"
import script from "./OffersDatesFilter.vue?vue&type=script&lang=js"
export * from "./OffersDatesFilter.vue?vue&type=script&lang=js"
import style0 from "./OffersDatesFilter.vue?vue&type=style&index=0&id=6877b77c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6877b77c",
  null
  
)

export default component.exports